import {consumeContext}           from "@Common/react/context";
import {ComponentLink,
        Link,
        makeChain}                from "@Common/react/cst2";
import {Load2}                    from "@Common/react/load2";

export const isFieldAiEligible = (templateBindingData, textField) => (

    makeChain<JSX.Element>()

    .then("templateSide", ({}, next:Link<JSX.Element, string>) => next(textField._parentContainer?.parentComponent?._name) )

    .then("allowOverride", ({}, next:Link<JSX.Element, boolean>) => next(
        // 0: "clip", 1: "fit to width", 2: "fit to box"
        textField?._overflowStrategy != 0
    ))

    .then("fontSize", ({}, next:Link<JSX.Element, number>) => next(
        textField?._font._size
    ))

    .then("areaOfTextbox", ({}, next:Link<JSX.Element, number>) => next(
        textField?._textRectangle?._width * textField?._textRectangle?._height
    ))

    .then("estimatedMaxCharacters", ({allowOverride, fontSize, areaOfTextbox}, next:Link<JSX.Element, number>) => next(
        // brute force analysis shows you need about 8.5sq pts of text area for each pnt size of font for a single character
        // We should keep an eye on this & update if this estimate needs to be tweaked.
        allowOverride ? Math.floor( (areaOfTextbox / fontSize) / 8.5 ) : Math.floor( ( (areaOfTextbox / fontSize) / 8.5 ) * .95 )
    ))

    .then("aiBlockedByBindings", ({templateSide}, next:Link<JSX.Element, boolean>) => next(
        ["xd.user", "xd.office", "xd.company", "xd.region", "xd.listing.listedPrice"].some((substring) => {
            return templateBindingData[templateSide]?.[textField.name]?.value?.includes(substring)
        })
    ))

    .then("enableAiTools", ({estimatedMaxCharacters, allowOverride, aiBlockedByBindings}, next:Link<JSX.Element, boolean>) => next(
        textField &&
        !textField?._isRichText &&
        !textField?._visualizationPermissions._noShow &&
        !aiBlockedByBindings &&
        // Might have to play with these numbers a bit
        // leaving code below even though this code could be written simply as "estimatedMaxCharacters > 50"
        ( (estimatedMaxCharacters > 50 && allowOverride) || estimatedMaxCharacters > 50 )
    ))

    .then(({enableAiTools}) => (
        !!enableAiTools
    ))

    .run()
);